/**
 * Watchlist persistence: `watchlist/main`, synced per user (field merge: `lists`, `activeId` and
 * `flags` merge independently on a conflict), cached in local storage. See sync/docStore.ts.
 */
import type { DocSync } from "../sync/client.ts";
import { SyncedDocStore } from "../sync/docStore.ts";
import type { KeyValueStorage } from "../workspacesSync.ts";
import { WATCHLIST_DOC_ID, defaultWatchlistDoc, sanitizeWatchlistDoc, type WatchlistDoc } from "./model.ts";

export type WatchlistStore = SyncedDocStore<WatchlistDoc>;

export function createWatchlistStore(opts: {
  storageKey: string;
  storage: KeyValueStorage;
  sync: boolean;
  docs?: DocSync;
  saveDelayMs?: number;
}): WatchlistStore {
  return new SyncedDocStore<WatchlistDoc>({
    docType: "watchlist",
    docId: WATCHLIST_DOC_ID,
    sanitize: sanitizeWatchlistDoc,
    seed: defaultWatchlistDoc,
    ...opts,
  });
}
